import { collection, getDocs, query, where } from 'firebase/firestore'
import React, { useEffect, useState } from 'react'
import { db } from '../../firebaseConfig/firebase'
import { Link } from 'react-router-dom'

const SearchShow = ({
    SelectProductFunction,
    SelectProductsFunction
}) => {

    const indexesCollection = collection(db, "indexes")

    const [productsIndex, setProductsIndex] = useState([])

    const [categoriesSuggestions, setCategoriesSuggestions] = useState([])
    const [productsSuggestions, setProductsSuggestions] = useState([])
    const [brandsSuggestions, setBrandsSuggestions] = useState([])

    const [productsFilteredList, setProductsFilteredList] = useState([])

    const [txtSearch, setTxtSearch] = useState("")

    const updateCategoriesSuggestions = async (e) => {

        if (e.length > 0) {
            const filteredItems = productsIndex.filter(item =>
                item.productCategories.toLowerCase().includes(e.toLowerCase())
            )

            setCategoriesSuggestions(
                [...new Set(
                    filteredItems.map((item) => (
                        item.productCategories.split(",").map(e => e.trim())
                    )).flat()
                )].filter(item =>
                    item.toLowerCase().includes(e.toLowerCase())
                )
            )

        } else {
            setCategoriesSuggestions([])
        }
    }

    const updateBrandsSuggestions = async (e) => {
        if (e.length > 2) {
            const filteredItems = productsIndex.filter(item =>
                item.productBrand.toLowerCase().includes(e.toLowerCase())
            )

            setBrandsSuggestions(
                filteredItems.map((item) => (
                    {
                        brand: item.productBrand,
                        categories: item.productCategories.split(",").map(e => e.trim())
                    }

                ))
                    .flatMap(item =>
                        item.categories.map(category => ({
                            brand: item.brand,
                            category: category
                        })))
                    .filter((value, index, self) =>
                        index === self.findIndex((t) => (
                            t.brand === value.brand && t.category === value.category
                        ))
                    ).filter(item => item.category)
            )
        } else {
            setBrandsSuggestions([])
        }
    }

    const updateProductsSuggestions = async (e) => {
        if (e.length > 0) {

            const filteredItems = productsIndex.filter(item =>
                item.productName.concat(" ", item.productBrand).toLowerCase().includes(e.toLowerCase())
            )

            setProductsFilteredList(filteredItems)
            const firstFilteredProducts = (filteredItems.map((product) => (product))).slice(0, 5)

            if (firstFilteredProducts.length > 0) {
                setProductsSuggestions(firstFilteredProducts)
            } else {
                setProductsSuggestions([])
            }


        } else {
            setProductsSuggestions([])
        }
    }

    const getProductsIndex = async () => {
        if (productsIndex.length === 0) {
            const productsIndexQuery = query(indexesCollection, where("code", "==", "productsIndex"));
            const productsIndexDocs = await getDocs(productsIndexQuery)
            if (productsIndexDocs.docs.length > 0) {
                setProductsIndex(
                    productsIndexDocs.docs[0].data().value
                        .filter(item => item.productState === true)
                        .sort((a, b) => a.productName.localeCompare(b.productName))
                )
            } else {
                setProductsIndex([])
            }
        }
    }

    const ClearSerach = async () => {
        setCategoriesSuggestions([])
        setBrandsSuggestions([])
        setProductsSuggestions([])
        setTxtSearch("")
    }

    const SelectCategory = async (e) => {
        ClearSerach()

        const filteredItems = productsIndex.filter(item =>
            item.productCategories.toLowerCase().includes(e.toLowerCase())
        )

        SelectProductsFunction(filteredItems)
    }

    const SelectBrand = async (e) => {
        ClearSerach()

        const filteredItems = productsIndex.filter(item =>
            item.productBrand.toLowerCase() === e.brand.toLowerCase()
            && item.productCategories.toLowerCase().includes(e.category.toLowerCase())
        )

        SelectProductsFunction(filteredItems)
    }

    useEffect(() => {
        getProductsIndex()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [txtSearch])

    return (
        <div className="mb-3">
            <div className="row">
                <div className="col-2">
                    <Link className="btn btn-info" to="/"><i className="fa-solid fa-left-long" /></Link>
                </div>
                <div className="col-10" style={{ position: "relative" }}>
                    <input
                        value={txtSearch}
                        onChange={(e) => {
                            setTxtSearch(e.target.value)
                            updateCategoriesSuggestions(e.target.value)
                            updateProductsSuggestions(e.target.value)
                            updateBrandsSuggestions(e.target.value)
                            SelectProductsFunction([])
                        }}
                        type='text'
                        className='form-control'
                        style={{ paddingLeft: "30px" }}
                    />
                    <i className="fa fa-search"
                        style={{
                            position: "absolute",
                            left: "20px",
                            top: "50%",
                            transform: "translateY(-50%)"
                        }} />
                    {/* style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%);" */}
                </div>
            </div>
            {categoriesSuggestions.length > 0 ? (
                <div className='row'>
                    <div className="col mt-3">
                        <hr></hr>
                        <h6>Categorías</h6>
                        {categoriesSuggestions.map((suggestion, index) => (
                            <div className='row text-start mt-2' key={index} onClick={() => SelectCategory(suggestion)}>
                                <div className='col'>
                                    <strong>
                                        {suggestion}
                                    </strong>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (<></>)}

            {brandsSuggestions.length > 0 ? (
                <div className='row'>
                    <div className="col mt-3">
                        <hr></hr>
                        <h6>Marcas</h6>
                        {brandsSuggestions.map((suggestion, index) => (
                            <div className='row text-start mt-2' key={index} onClick={() => SelectBrand(suggestion)}>
                                <div className='col'>
                                    <div>
                                        <strong>{suggestion.brand}</strong><br />
                                        <span>en {suggestion.category}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (<></>)}

            {productsSuggestions.length > 0 ? (
                <div className='row'>
                    <div className="col mt-3">
                        <hr></hr>
                        <h6>Productos</h6>
                        {productsSuggestions.map((suggestion, index) => (
                            <div className='row text-start mt-2' key={index}
                                onClick={() => {
                                    SelectProductFunction(suggestion.productId)
                                }}
                                data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                                <div className='col'>
                                    <div className='row'>
                                        <div className='col-2'>
                                            <img style={{ width: "100%" }} src={suggestion.productImage} alt={suggestion.productname} />
                                        </div>
                                        <div className='col-7'>
                                            <strong>{suggestion.productName}</strong>
                                            <br />
                                            {suggestion.productBrand}
                                        </div>
                                        <div className='col-2'>
                                            ₡{suggestion.productPrice.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        <div className='btn btn-link mt-3'>
                            <strong onClick={() => {
                                ClearSerach()
                                SelectProductsFunction(productsFilteredList)
                            }}>
                                Ver todos ({productsFilteredList.length})
                            </strong>
                        </div>
                    </div>
                </div>
            ) : (<></>)}
        </div>
    )
}

export default SearchShow